const groupAndSpreadMarkers = (
  campaigns: any[],
  spreadInMeters: number = 20,
  groupingRadiusInMeters: number = 0
): any[] => {
  const spreadInDegrees = spreadInMeters / 111_320;
  const grouped: any[][] = [];

  const toRad = (val: number) => (val * Math.PI) / 180;

  const distanceBetween = (a: any, b: any) => {
    const R = 6371000; // Earth radius in meters
    const dLat = toRad(parseFloat(b.latitude) - parseFloat(a.latitude));
    const dLng = toRad(parseFloat(b.longitude) - parseFloat(a.longitude));
    const lat1 = toRad(parseFloat(a.latitude));
    const lat2 = toRad(parseFloat(b.latitude));

    const aVal =
      Math.sin(dLat / 2) ** 2 +
      Math.sin(dLng / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(aVal), Math.sqrt(1 - aVal));

    return R * c;
  };

  // Grouping nearby markers
  campaigns.forEach((marker) => {
    let foundGroup = false;

    for (const group of grouped) {
      if (group.some((existing) => distanceBetween(marker, existing) <= groupingRadiusInMeters)) {
        group.push(marker);
        foundGroup = true;
        break;
      }
    }

    if (!foundGroup) {
      grouped.push([marker]);
    }
  });

  const spreadMarkers: any[] = [];

  grouped.forEach((group) => {
    const base = {
      latitude: parseFloat(group[0].latitude),
      longitude: parseFloat(group[0].longitude),
    };

    if (group.length === 1) {
      const originalLat = parseFloat(group[0].latitude);
      const originalLng = parseFloat(group[0].longitude);

      spreadMarkers.push({
        ...group[0],
        latitude: originalLat,
        longitude: originalLng,
        originalLatitude: originalLat,
        originalLongitude: originalLng,
      });
    } else {
      const count = group.length;

      group.forEach((item, index) => {
        const originalLat = parseFloat(item.latitude);
        const originalLng = parseFloat(item.longitude);

        const angle = (2 * Math.PI * index) / count;

        const offsetLat = spreadInDegrees * Math.sin(angle);
        const offsetLng =
          (spreadInDegrees * Math.cos(angle)) /
          Math.cos(base.latitude * Math.PI / 180);

        spreadMarkers.push({
          ...item,
          latitude: base.latitude + offsetLat,
          longitude: base.longitude + offsetLng,
          originalLatitude: originalLat,
          originalLongitude: originalLng,
        });
      });
    }
  });

  return spreadMarkers;
};

export default groupAndSpreadMarkers;
